"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _wolfy87Eventemitter = _interopRequireDefault(require("wolfy87-eventemitter"));
var _common = require("./utils/common");
var _moduleManage = _interopRequireDefault(require("./module/moduleManage"));
var _pageManage = _interopRequireDefault(require("./module/pageManage"));
var _pluginManage = _interopRequireDefault(require("./module/pluginManage"));
var _layoutManage = _interopRequireDefault(require("./module/layoutManage"));
var _hmrManage = _interopRequireDefault(require("./hmrManage"));
var _getCompDBInfoList = _interopRequireDefault(require("./utils/getCompDBInfoList"));
var _logger = _interopRequireDefault(require("./utils/logger"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * 无极组件加载器的管理入口
 */
var WujiComp = /*#__PURE__*/function (_EventEmitter) {
  (0, _inherits2["default"])(WujiComp, _EventEmitter);
  var _super = _createSuper(WujiComp);
  function WujiComp() {
    var _this;
    (0, _classCallCheck2["default"])(this, WujiComp);
    _this = _super.call(this);
    // 初始化两个Promise，尽量保证与业务的请求并行触发
    _this.getCompDBPromise = null;
    _this.hmrPromise = Promise.resolve();
    // hmr的管理器
    _this.hmrManage = new _hmrManage["default"]();
    return _this;
  }

  /**
   * 初始化的配置
   * 1、主要是组件商店的地址、组件基类
   * 2、公共的外部依赖，比如vue、antd、echart等（这样就不用暴露到window上，内部也会兜底取window -- webpack externals）
   * @param {*} wujiExternals 无极的外部扩展（目前仅基类 + 商店url）
   * @param {*} allWebpackExternals 所有公共的外部依赖，比如vue、antd、echart等
   */
  (0, _createClass2["default"])(WujiComp, [{
    key: "config",
    value: function config(wujiExternals, allWebpackExternals) {
      // 用于组件商店的请求url
      this.dbUrl = wujiExternals.dbUrl;
      this.moduleManage = new _moduleManage["default"](wujiExternals, allWebpackExternals);
      this.pageManage = new _pageManage["default"](null, allWebpackExternals);
      this.pluginManage = new _pluginManage["default"](null, allWebpackExternals);
      this.layoutManage = new _layoutManage["default"](null, allWebpackExternals);
    }
  }, {
    key: "setExternalDeps",
    value: function setExternalDeps(key, deps) {
      this.moduleManage.allWebpackExternals[key] = deps;
      this.pageManage.allWebpackExternals[key] = deps;
      this.pluginManage.allWebpackExternals[key] = deps;
      this.layoutManage.allWebpackExternals[key] = deps;
    }

    /**
     * @typedef {Object} ComponentHubQueryObject 组件商店聚合接口的queryObject
     * @property {string} projectId [可选]项目id
     * @property {string} projectEnv [可选]项目环境
     * @property {string} hubList [可选]组件商店列表，逗号分隔
     * @property {string} env 组件商店环境：test | formal | grayScale
     */

    /**
     * 发起组件商店的请求
     * @param {ComponentHubQueryObject} componentHubQueryObject
     */
  }, {
    key: "fetchCompDBInfo",
    value: function fetchCompDBInfo() {
      var _this2 = this;
      var componentHubQueryObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var forceRefresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (this.getCompDBPromise && !forceRefresh) return;
      this.getCompDBPromise = (0, _getCompDBInfoList["default"])(this.dbUrl, componentHubQueryObject).then(function (result) {
        _this2.moduleManage.setCompDBList(result);
      });
    }

    /**
     * 组件hmr的启动
     * @param {*} port
     */
  }, {
    key: "hmrStart",
    value: function () {
      var _hmrStart = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(port, opts) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.moduleManage) {
                _context.next = 3;
                break;
              }
              _logger["default"].error('%c wujiComp config not configured!', 'color: red;');
              return _context.abrupt("return");
            case 3:
              this.hmrPromise = this.hmrManage.hmrStart(this.moduleManage, [this.getCompDBPromise], port, opts);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function hmrStart(_x, _x2) {
        return _hmrStart.apply(this, arguments);
      }
      return hmrStart;
    }()
    /**
     * @typedef {CompKeysOptions} 加载组件列表的配置项
     * @property {string[]} groupList 分组信息，只拉取默认商店和这个分组里面的私有商店, 如果不传，拉取的是全量的group
     * @property {boolean} editor 是否是编辑时
     * @property {string} projectId 项目id
     * @property {string} projectEnv 项目环境
     */
    /**
     * 暴露给外部调用的获取组件单一实例集合
     * @param {*} compKeys 按需获取的组件key集（不传则全量）
     * @param {CompKeysOptions} opts 配置项
     */
  }, {
    key: "getCompsByCompKeys",
    value: function () {
      var _getCompsByCompKeys = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(compKeys, opts, dependencies) {
        var _this3 = this;
        var baseObj, hmrObj;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (0, _common.allSettled)([this.getCompDBPromise, this.hmrPromise]);
            case 3:
              _context2.next = 5;
              return this.moduleManage.initCompsByCompKeys(compKeys, opts, dependencies);
            case 5:
              _context2.next = 7;
              return this.moduleManage.initHMRComponents();
            case 7:
              if (!compKeys || opts !== null && opts !== void 0 && opts.lazyLoadRestOfAllComponents) {
                compKeys = this.moduleManage.getCompKeysByOpts(opts);
              }
              baseObj = {}; // 获取并控制显示hmr成功的组件
              hmrObj = {};
              Object.keys(this.moduleManage.installedModules).forEach(function (compKey) {
                var isHmr = _this3.moduleManage.installedModules[compKey].isHmr;
                // 排除不在本次调用中的组件
                if (!isHmr && (compKeys || []).indexOf(compKey) === -1) {
                  return false;
                }
                var _this3$moduleManage$i = _this3.moduleManage.installedModules[compKey],
                  compInfo = _this3$moduleManage$i.compInfo,
                  compDB = _this3$moduleManage$i.compDB;
                if (compInfo) {
                  baseObj[compKey] = _objectSpread(_objectSpread({}, compInfo), {}, {
                    compDB: compDB
                  });
                  if (isHmr) {
                    hmrObj[compKey] = compInfo;
                  }
                }
              });
              window.__wjiComp_baseObj__ = baseObj;
              if (Object.keys(hmrObj).length > 0) {
                window.__wjiComp_hmrObj__ = hmrObj;
              }
              return _context2.abrupt("return", baseObj);
            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](0);
              _logger["default"].error('%c wujiComp getCompsByCompKeys request failed!', 'color: red;', _context2.t0);
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 16]]);
      }));
      function getCompsByCompKeys(_x3, _x4, _x5) {
        return _getCompsByCompKeys.apply(this, arguments);
      }
      return getCompsByCompKeys;
    }()
    /**
     * 暴露给cos文件的组件注册入口（类似amd requirejs的define定义）
     * @param {*} compKey 组件key
     * @param {*} compDependencies 无极组件的依赖
     * @param {*} webpackExternals 公共的外部依赖 -- webpack externals
     * @param {*} compFunc 懒执行的组件函数
     */
  }, {
    key: "register",
    value: function register(compKey, compDependencies, webpackExternals, compFunc) {
      this.moduleManage.register(compKey, compDependencies, webpackExternals, compFunc);
    }

    /**
     * 针对异步加载的组件，我们只下载这个组件的component.js，这个函数用于处理component.js的加载
     */
  }, {
    key: "registerComponentJs",
    value: function registerComponentJs(compKey, compDependencies, webpackExternals, compFunc) {
      this.moduleManage.registerComponentJS(compKey, compDependencies, webpackExternals, compFunc);
    }
  }, {
    key: "setStaticFileHost",
    value: function setStaticFileHost(registry, group, prefix) {
      this.moduleManage.setStaticFileHost(registry, group, prefix);
    }

    /**
     * 暴露给cos文件的组件注册入口（类似amd requirejs的define定义）
     * @param {*} pageId 页面ID
     * @param {*} compDependencies 无极组件的依赖
     * @param {*} webpackExternals 公共的外部依赖 -- webpack externals
     * @param {*} compFunc 懒执行的组件函数
     */
  }, {
    key: "registerPage",
    value: function registerPage(pageId, compDependencies, webpackExternals, compFunc) {
      this.pageManage.register(pageId, compDependencies, webpackExternals, compFunc);
    }
  }, {
    key: "registerPlugin",
    value: function registerPlugin(pluginId, compDependencies, webpackExternals, compFunc) {
      this.pluginManage.register(pluginId, compDependencies, webpackExternals, compFunc);
    }
  }, {
    key: "registerLayout",
    value: function registerLayout(pluginId, compDependencies, webpackExternals, compFunc) {
      this.layoutManage.register(pluginId, compDependencies, webpackExternals, compFunc);
    }
  }, {
    key: "getPlugin",
    value: function () {
      var _getPlugin = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(pluginId) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.pluginManage.getInfo(pluginId);
            case 2:
              return _context3.abrupt("return", _context3.sent);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getPlugin(_x6) {
        return _getPlugin.apply(this, arguments);
      }
      return getPlugin;
    }()
  }, {
    key: "getPageInfo",
    value: function () {
      var _getPageInfo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(pageId) {
        var deps;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              // 提前加载页面组件依赖
              deps = this.pageManage.getCompDependencies(pageId); // 确保请求都返回
              _context4.next = 3;
              return (0, _common.allSettled)([this.getCompDBPromise, this.hmrPromise]);
            case 3:
              _context4.next = 5;
              return this.moduleManage.initCompModulesByCompKeys(deps, false);
            case 5:
              if (!(this.pageManage.webpackExternals.includes('React') && !this.pageManage.allWebpackExternals.React)) {
                _context4.next = 8;
                break;
              }
              _context4.next = 8;
              return this.moduleManage.loadReactDependencies();
            case 8:
              if (!(this.pageManage.webpackExternals.includes('vue3') && !this.pageManage.allWebpackExternals.vue3)) {
                _context4.next = 11;
                break;
              }
              _context4.next = 11;
              return this.moduleManage.loadVue3Dependencies();
            case 11:
              return _context4.abrupt("return", this.pageManage.getInfo(pageId));
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getPageInfo(_x7) {
        return _getPageInfo.apply(this, arguments);
      }
      return getPageInfo;
    }()
  }, {
    key: "getLayout",
    value: function () {
      var _getLayout = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(layoutId) {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.layoutManage.getInfo(layoutId);
            case 2:
              return _context5.abrupt("return", _context5.sent);
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getLayout(_x8) {
        return _getLayout.apply(this, arguments);
      }
      return getLayout;
    }()
    /**
     * 预加载、懒执行模式
     * 用于无极组件开发的依赖声明(基于原生写法的转换：import wInput from "@wuji/c/public/w-input")
     * @param {*} compKey
     */
  }, {
    key: "require",
    value: function require(compKey) {
      return this.moduleManage.require(compKey);
    }

    /**
     * 懒加载、懒执行模式
     * 用于无极组件开发的依赖声明(类似webpack的require.ensure异步写法：wujiComp.asyncRequire("@wuji/c/public/w-input"))
     * @param {*} compKey
     */
  }, {
    key: "asyncRequire",
    value: function () {
      var _asyncRequire = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(compKey) {
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.moduleManage.asyncRequire(compKey);
            case 2:
              return _context6.abrupt("return", _context6.sent);
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function asyncRequire(_x9) {
        return _asyncRequire.apply(this, arguments);
      }
      return asyncRequire;
    }() // --------------------------------------------------------------------------------
    /**
     * hmr 组件热更新通知
     * @param {*} compKey
     * @param {*} compInfo
     */
  }, {
    key: "hmrCompChange",
    value: function hmrCompChange(compKey, compInfo) {
      var curCompInfo = this.moduleManage.require(compKey);
      curCompInfo.config = compInfo.config;
      this.emitEvent('hmrCompChange', [compKey, curCompInfo]);
    }

    /**
     * hmr 插件更新通知
     * @param {*} pluginId
     * @param {*} pluginInfo
     */
  }, {
    key: "hmrPluginChange",
    value: function hmrPluginChange(pluginId, pluginInfo) {
      _logger["default"].info('hmrPluginChange');
      this.emitEvent('hmrPluginChange', [pluginId, pluginInfo]);
    }

    /**
     * 注册特殊的loader
     * @param {string} type
     * @param {function} loader
     */
  }, {
    key: "registerModuleLoader",
    value: function registerModuleLoader(type, loader) {
      this.moduleManage.registerModuleLoader(type, loader);
    }
  }, {
    key: "setDefaultLibrary",
    value: function setDefaultLibrary(library) {
      this.moduleManage.setDefaultLibrary(library);
    }
  }]);
  return WujiComp;
}(_wolfy87Eventemitter["default"]);
var _default = WujiComp;
exports["default"] = _default;